/**
 * AUDIT_LOGIN_TEMP — ВРЕМЕННЫЙ ФУНКЦИОНАЛ (вход для аудиторской проверки).
 * Инструкция по полному удалению — в server/config/auditLogin.js.
 *
 * Страница входа по логину и паролю показывается ТОЛЬКО по этому адресу и
 * ТОЛЬКО пока нет действующей сессии. С обычного входа (Яндекс ID) на нее
 * ничего не ведет — попасть можно только набрав адрес вручную.
 */
export const AUDIT_LOGIN_ROUTE_PATH = '/audit-login';
